// TEMPLATE — pending licensed attorney review (insurance + financial services).
// Do not treat the seeded copy as final legal text.
import { createFileRoute } from "@tanstack/react-router";
import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { seo } from "@/lib/seo";

export const Route = createFileRoute("/accessibility")({
  head: () =>
    seo({
      title: "Accessibility · Currency Thoughts",
      description:
        "Our commitment to WCAG 2.1 AA and an accessible experience for every visitor.",
      canonical: "/accessibility",
    }),
  component: () => (
    <LegalPageLayout
      slug="accessibility"
      fallbackTitle="Accessibility"
      fallbackHeadline="A platform open to every family."
    />
  ),
});